export default __webpack_public_path__ + "static/media/eduBlue.85730043.svg";